@if (!loading) {
  <main class="col p-2 p-lg-4">
    <h1 class="h5">{{ offer }}</h1>
    <div class="card shadow border-0 p-3">
      <div class="d-block d-lg-flex align-items-center">
        <img [src]="imageService.getImageUrl($safeNavigationMigration(offer?.product?.logo), 250, 250, false)" class="img-fluid rounded me-0 me-lg-3 mb-2 mb-lg-0" alt="Offer Image" id="offer-image">
        <div>
          <table class="table table-bordered" id="offer-table">
            <tbody>
              <tr>
                <th>Geos</th>
                <td>{{ offer?.getGeoList() }}</td>
              </tr>
              <tr>
                <th>Payout Type</th>
                <td>{{ ('conversionType.' + $safeNavigationMigration(offer?.conversionType)) | translate }}</td>
              </tr>
              <tr>
                <th>Payout</th>
                <td>{{ $safeNavigationMigration(offer?.getRegistrationPayout()) | currency:2:$safeNavigationMigration(offer?.currency?.isoCode) }}</td>
              </tr>
              @if (customPayout) {
                <tr>
                  <th>Custom payout</th>
                  <td>
                    @if (customPayout.payoutAmount !== null) {
                      <span
                      class="fw-bold">{{ customPayout.payoutAmount | currency:2:$safeNavigationMigration(customPayout.currency?.isoCode) }}</span>
                    }
                    @if (customPayout.payoutAmount === null && customPayout.payoutPercent !== null) {
                      <span
                      class="fw-bold">{{ customPayout.payoutPercent }} %</span>
                    }
                  </td>
                </tr>
              }
              <tr>
                <th>Approval Status</th>
                <td>
                  <span class="badge" [ngClass]="getOfferStatusClass()">{{ ('partnerOfferStatus.' + getOfferStatus()) | translate }}</span>
                </td>
              </tr>
              <tr>
                <th>Vertical</th>
                <td>
                  @if (offer?.verticals) {
                    @for (vertical of offer?.verticals; track vertical; let last = $last) {
                      {{ getVerticalName(vertical) | translate }}@if (!last) {
                      /
                    }
                  }
                }
              </td>
            </tr>
          </tbody>
        </table>
        @if (getOfferStatus() === 'apply_to_run') {
          <button (click)="applyOffer()" [disabled]="applying" class="btn btn-primary fw-bold" type="button">
            Apply to Run
          </button>
        }
      </div>
    </div>
  </div>
  <div class="card shadow border-0 mt-4 p-3">
    <h2 class="h6">Offer Description</h2>
    <p [innerHTML]="$safeNavigationMigration(offer?.descriptionHtml)"></p>
  </div>
  @if (subIdPayouts.length) {
    <div class="card shadow border-0 mt-4 p-3">
      <h2 class="h6">Subid specific payouts</h2>
      <div class="table-responsive">
        <table class="table table-hover table-striped mb-0">
          <thead class="table-light">
            <tr>
              <th>Subid</th>
              <th>Custom payout</th>
            </tr>
          </thead>
          <tbody>
            @for (subIdPayout of subIdPayouts; track subIdPayout) {
              <tr>
                <td>{{ subIdPayout.subId }}</td>
                <td>
                  @if (subIdPayout.customPayout.payoutAmount !== null) {
                    <span
                    class="fw-bold">{{ subIdPayout.customPayout.payoutAmount | currency:2:$safeNavigationMigration(subIdPayout.customPayout.currency?.isoCode) }}</span>
                  }
                  @if (subIdPayout.customPayout.payoutAmount === null && subIdPayout.customPayout.payoutPercent !== null) {
                    <span
                    class="fw-bold">{{ subIdPayout.customPayout.payoutPercent }} %</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
  <!--  <div class="card shadow border-0 mt-4 p-3">-->
  <!--    <h2 class="h6">Performance Overview</h2>-->
  <!--    <div class="table-responsive">-->
  <!--      <table class="table table-hover table-striped text-center">-->
  <!--        <thead class="table-light">-->
  <!--        <tr>-->
  <!--          <th>Date</th>-->
  <!--          <th>Clicks</th>-->
  <!--          <th>Conversions</th>-->
  <!--          <th>EPC</th>-->
  <!--          <th>Revenue</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr>-->
<!--          <td>Today</td>-->
<!--          <td>150</td>-->
<!--          <td>12</td>-->
<!--          <td>$1.50</td>-->
<!--          <td>$18.00</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td>Yesterday</td>-->
<!--          <td>200</td>-->
<!--          <td>18</td>-->
<!--          <td>$1.75</td>-->
<!--          <td>$31.50</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </div>-->
<!--  </div>-->
</main>
}
